import Image from 'next/image'

import { formatPrice } from '~/utils/graphqlDataFormatters'

import { CollapsibleMenu } from '~/components/Restaurant/CollapsibleMenu/CollapsibleMenu'
import { ReservableCrossSell } from '~/components/Restaurant/ReservableCrossSellItem/ReservableCrossSellItem'
import { ReservableMenuWithCrossSells } from '~/components/Restaurant/ReservableMenuWithCrossSells/ReservableMenuWithCrossSells'
import { ReservableExtra } from '~/generated/graphql'
import { gt } from '~/locale'
import { DangerousTranslate } from '~/shared/atoms/DangerousTranslate'
import { SingleMenu } from '~/shared/molecules/Menu/MenuView'

import { ChmInfo, Description, DescriptionContainer, Eyebrow, Name, PhotoWrapper, Wrapper } from './ReservableExtraCardShards'

export type ReservableExtraCardItem = Pick<ReservableExtra, 'id' | 'price' | 'name'> & {
  image?: Pick<NonNullable<ReservableExtra['image']>, 'preview'> | null
  menus?: Array<SingleMenu> | null
}

type ReservableExtraCardProps = {
  reservableExtra: ReservableExtraCardItem
  crossSells: ReservableCrossSell[]
  onReserveClick: () => void
}

export const ReservableExtraCard = ({ reservableExtra, crossSells, onReserveClick }: ReservableExtraCardProps) => {
  const image = reservableExtra.image

  return (
    <Wrapper>
      <ChmInfo>
        <DescriptionContainer>
          <Eyebrow>{gt.tp('RestaurantPage', 'Flagship menu')}</Eyebrow>
          <Name>{reservableExtra.name}</Name>
          <Description>
            <DangerousTranslate
              text={gt.tp('RestaurantPage', 'Only {{ price }} / menu', {
                price: `<b>${formatPrice(reservableExtra.price)}</b>`,
              })}
            />
          </Description>
        </DescriptionContainer>
        <PhotoWrapper>
          {image && <Image src={image.preview || ''} height={120} width={213} layout='responsive' objectFit='cover' />}
        </PhotoWrapper>
      </ChmInfo>
      <CollapsibleMenu>
        <ReservableMenuWithCrossSells menus={reservableExtra.menus || []} crossSells={crossSells} onReserveClick={onReserveClick} />
      </CollapsibleMenu>
    </Wrapper>
  )
}
